import React, { forwardRef, useEffect } from "react";
import { Form as SForm, Button, Icon, Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, ModalContent, ModalActions } from "@/components/bp/bp-ui";
import { Formik, FieldArray, FormikProps } from "formik";
import * as yup from "yup";
import { LabKitClient, MarkerAllelesSearchDto, SampleCreateKeyboardModel, SampleSystemModel } from "@app/api2/api";
import SemanticFormikInput from "@common/Forms/SemanticFormikInput";
import SemanticFormikSelect from "@common/Forms/SemanticFormikSelect";
import { useKits } from "../../Hooks/UseKits";
import { SampleKeyboardInputSchema } from './Tabs/SampleKeyboardInput.Schema';
import { useDnaKitOptions } from "../Hooks/LookupOptions";
import { useQuery } from "@tanstack/react-query";
import { queriesClient } from "@app/api2/Clients";
import { useDialogContext } from "../../Hooks/DialogContext";
import { BPButton } from "@/components/bp/bpbutton";

export interface IDropdownItem<T> { key?: any; value: T; text: string }

export interface SampleCreateKeyboardFormProps {
    labId: number;
    initialValues?: SampleCreateKeyboardModel;
    onSubmit: (values: SampleCreateKeyboardModel) => Promise<any> | void;
    onValidationResult?: (isValid: boolean) => void;
    // kitOptions?: Array<IDropdownItem<number>>;
    // Optional function to load systems for a kit. If omitted component will call LabKitClient.getSystems(kitId, labId)
    // loadKitSystems?: (kitId: number) => Promise<SampleSystemModel[]>;
    submitLabel?: string;
    submitting?: boolean;
}

// const SForm = SForm as any; // to avoid semantic-ui-react types which are not compatible with formik

// interface FormValues {
//     kitId: number;
//     name: string;
//     systems: SampleSystemModel[];
// }

const defaultInitial: SampleCreateKeyboardModel = {
    kitId: 0,
    name: "",
    systems: null,
};

export const SampleCreateKeyboardForm = forwardRef<FormikProps<SampleCreateKeyboardModel>, SampleCreateKeyboardFormProps>((props, ref) => {
    const initial = props.initialValues ?? defaultInitial;

    const kits = useKits({ labId: props.labId, defaultId: initial.kitId ?? 0 });

    const markers = useQuery({
        queryKey: ['kitMarkers', kits.selectedId],
        queryFn: async () => {
            var data = await queriesClient.getKitMarkers(kits.selectedId);
            return data;
        },
        enabled: !!kits.selectedId,
    });

    const { onSubmit, submitLabel = "Save", submitting = false } = props;


    return (
        <Formik initialValues={{
            ...initial,
            kitId: kits.selectedId,
            systems: (initial.systems ?? markers?.data?.systems.map(s => ({ name: s.name, allele1: '', allele2: '' })) ?? [])
        }}
            onSubmit={onSubmit}
            innerRef={ref}
            validationSchema={SampleKeyboardInputSchema}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}>
            {(formik: FormikProps<SampleCreateKeyboardModel>) => {
                return (
                    <>
                        <SForm as={ModalContent} loading={submitting}>
                            <SemanticFormikSelect
                                name="kitId"
                                label={"Loci Order"}
                                placeholder={"Select"}
                                required
                                {...kits.getDropdownProps()} />

                            <SemanticFormikInput
                                name="name"
                                label={"Sample Name"}
                                placeholder={"Sample Name"} />

                            <FieldArray name="systems">
                                {arrayHelpers => (
                                    <Table compact>
                                        <TableHeader>
                                            <TableRow>
                                                <TableHeaderCell collapsing>{window.translation?.common?.system ?? "System"}</TableHeaderCell>
                                                <TableHeaderCell>{window.translation?.common?.allele ?? "Allele"}</TableHeaderCell>
                                                <TableHeaderCell>{window.translation?.common?.allele ?? "Allele"}</TableHeaderCell>
                                                <TableHeaderCell />
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {(formik.values.systems || []).map((sys, index) => (
                                                <TableRow key={index}>
                                                    <TableCell collapsing>
                                                        {sys.name}
                                                        {/* <SemanticFormikInput
                        name={`systems[${index}].name`}
                        placeholder={window.translation?.common?.system ?? "System"}
                    /> */}
                                                    </TableCell>
                                                    <TableCell>
                                                        <SemanticFormikInput
                                                            name={`systems[${index}].allele1`}
                                                            placeholder={window.translation?.common?.allele ?? "Allele"} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <SemanticFormikInput
                                                            name={`systems[${index}].allele2`}
                                                            placeholder={window.translation?.common?.allele ?? "Allele"} />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                            </FieldArray>

                            {/* <div style={{ marginTop: 10 }}>
        <BPButton icon type="button" color="green" onClick={() => setFieldValue("systems", [...(values.systems || []), { name: "", allele1: "", allele2: "" }])}>
            <Icon name="plus" />
        </BPButton>
    </div> */}

                            {/* <div style={{ marginTop: 12 }}>
        <BPButton primary type="submit">{submitLabel}</BPButton>
    </div> */}
                        </SForm>
                        <ModalActions>
                            <BPButton primary type="submit" onClick={async () => {
                                formik.handleSubmit();
                            }}>{submitLabel}</BPButton>
                        </ModalActions>
                    </>
                );
            }}
        </Formik>
    );
});

export default SampleCreateKeyboardForm;